/**
 * Creates a {@link Deferred} object.
 * @public
 * @returns {@link Deferred} object.
 */
// eslint-disable-next-line @typescript-eslint/promise-function-async
export function deferred() {
    let resolveAcc;
    let rejectAcc;
    const prom = new Promise((resolve, reject) => {
        resolveAcc = resolve;
        rejectAcc = reject;
    });
    prom.reject = error => rejectAcc(error);
    prom.resolve = value => resolveAcc(value);
    return prom;
}
